import { AutogenModelCompany, AutogenRowCompany } from "./autogen/AutogenModelCompany";

export class ModelCompany extends AutogenModelCompany<RowCompany> {
	constructor() {
		super(RowCompany);
	}
}

export class RowCompany extends AutogenRowCompany {
}